import { TrendingUp, Star, DollarSign, BarChart3 } from "lucide-react";
import { formatCurrency } from "../../lib/helpers";

const StatsBar = ({ profitableCount, totalAnalyzed, avgDealScore, avgCashFlow, analysisLoadProgress, properties }) => {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-5" data-testid="stats-summary-bar">
      <div className="flex items-center gap-3 p-3 rounded-lg bg-secondary/30 border border-border">
        <div className="w-8 h-8 rounded-full bg-emerald-500/10 flex items-center justify-center flex-shrink-0">
          <TrendingUp className="w-4 h-4 text-emerald-500" />
        </div>
        <div>
          <p className="text-[10px] text-muted-foreground uppercase tracking-wider">Profitable</p>
          <p className="font-mono text-base font-bold text-emerald-500">
            {profitableCount}
            <span className="text-xs text-muted-foreground font-normal">/{totalAnalyzed}</span>
          </p>
        </div>
      </div>
      <div className="flex items-center gap-3 p-3 rounded-lg bg-secondary/30 border border-border">
        <div className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 ${avgDealScore >= 50 ? "bg-emerald-500/10" : "bg-amber-500/10"}`}>
          <Star className="w-4 h-4 text-amber-500" />
        </div>
        <div>
          <p className="text-[10px] text-muted-foreground uppercase tracking-wider">Avg Score</p>
          <p className={`font-mono text-base font-bold ${avgDealScore >= 60 ? "text-emerald-500" : avgDealScore >= 40 ? "text-amber-500" : "text-red-500"}`}>
            {avgDealScore}
            <span className="text-xs text-muted-foreground font-normal">/100</span>
          </p>
        </div>
      </div>
      <div className="flex items-center gap-3 p-3 rounded-lg bg-secondary/30 border border-border">
        <div className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 ${avgCashFlow >= 0 ? "bg-emerald-500/10" : "bg-red-500/10"}`}>
          <DollarSign className={`w-4 h-4 ${avgCashFlow >= 0 ? "text-emerald-500" : "text-red-500"}`} />
        </div>
        <div>
          <p className="text-[10px] text-muted-foreground uppercase tracking-wider">Avg Cash Flow</p>
          <p className={`font-mono text-base font-bold ${avgCashFlow >= 0 ? "text-emerald-500" : "text-red-500"}`}>
            {formatCurrency(avgCashFlow)}
            <span className="text-xs text-muted-foreground font-normal">/mo</span>
          </p>
        </div>
      </div>
      <div className="flex items-center gap-3 p-3 rounded-lg bg-secondary/30 border border-border">
        <div className="w-8 h-8 rounded-full bg-blue-500/10 flex items-center justify-center flex-shrink-0">
          <BarChart3 className="w-4 h-4 text-blue-400" />
        </div>
        <div>
          <p className="text-[10px] text-muted-foreground uppercase tracking-wider">Analyzed</p>
          <p className="font-mono text-base font-bold text-foreground">
            {analysisLoadProgress.loaded}
            <span className="text-xs text-muted-foreground font-normal">/{properties.length}</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default StatsBar;
